<template>
  <div class="store-container">
    <!-- <a class="store-link text-link" href="/gift"> GIFT CARDS </a> -->

    <!-- <a class="store-link" href="/gift">
      <img
        class="store-icon"
        src="../../assets/images/icons/gift_white.svg"
        alt="store"
      />
      <span class="store-text">SEND A GIFT</span>
    </a> -->
  </div>
</template>

<script>
import { mapMutations } from "vuex"
export default {
  methods: {
    ...mapMutations("Util", [
      "setNavbarDrawerShowing",
      "setPageLoading",
      "setShowGameContainer",
    ]),
    async goPath (path) {
      this.setShowGameContainer(false)
      this.setNavbarDrawerShowing(false)
      this.setPageLoading(true)
      if (this.$route.path !== path) {
        await this.$router.push(path)
      }
      this.setPageLoading(false)
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/_mixins.scss";
@import "@/assets/style/_variables.scss";
.store-container {
  margin-left: auto;
  cursor: pointer;
  background-origin: padding-box;
  border-radius: 4px;
  transition: background-color 0.2s ease-in;
  display: flex;
  .store-link {
    display: flex;
    padding: 0.8rem 1.4rem;
    font-family: $font-display;
    font-size: 2.5rem;
    font-weight: 700;
    text-decoration: none;
    color: rgb(172, 172, 172);
    margin-left: 1rem;
    &.text-link {
      font-family: $font-display;
      font-weight: 700;
      font-size: 1.5rem;
      @include desktop-down {
        display: none;
      }
    }
    @include desktop-down {
      // margin-bottom: 2rem;
      margin-left: 0;
      color: #8b8b8b;
    }
    .store-icon {
      width: 2.1rem;
      @include desktop-down {
        opacity: 0.6;
      }
    }
    .store-text {
      margin-left: 2rem;
      @include desktop-large {
        display: none;
      }
    }
    &:hover {
      background-color: #2f2f31;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/navigation/StoreContainer.vue